var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 221.75 108.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#b3b3b3;}.cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}.cls-2{stroke:#000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.5,33.09s17.42,.5,34.31-21.74c13.93-18.34,31.93-5.43,31.93-5.43,0,0-3.82,4.79-5.6,10.66-2.5,8.22,3.68,16.52,12.28,16.52h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.73,11.35c13.93-18.34,31.93-5.43,31.93-5.43,0,0-3.82,4.79-5.6,10.66-2.5,8.22,3.68,16.52,12.28,16.52h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.34,33.09s17.42,.5,34.31-21.74c13.93-18.34,31.93-5.43,31.93-5.43,0,0-3.82,4.79-5.6,10.66-2.5,8.22,3.68,16.52,12.28,16.52h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.81,48.41c13.93-18.34,31.93-5.43,31.93-5.43,0,0-3.82,4.79-5.6,10.66-2.5,8.22,3.68,16.52,12.28,16.52h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.5,70.15s6.81,.19,16.03-5.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M147.34,70.15h0c-8.59,0-14.77-8.3-12.28-16.52,1.78-5.87,5.6-10.66,5.6-10.66,0,0-6.19-4.44-14.11-4.41,0,0-10.22,0-18.78,11.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.19,32.16c6.65-2.11,16.27-7.35,26.12-20.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M181.64,48.41c13.93-18.34,31.93-5.43,31.93-5.43,0,0-3.82,4.79-5.6,10.66-2.5,8.22,3.68,16.52,12.28,16.52h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M147.34,70.15s3,.09,7.71-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.5,107.22s17.42,.5,34.31-21.74c13.93-18.34,31.93-5.43,31.93-5.43,0,0-3.82,4.79-5.6,10.66-2.5,8.22,3.68,16.52,12.28,16.52h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.74,100.73c4.98-3.22,10.51-8.04,15.98-15.25,13.93-18.34,31.93-5.43,31.93-5.43,0,0-3.82,4.79-5.6,10.66-2.5,8.22,3.68,16.52,12.28,16.52h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.34,107.22s17.42,.5,34.31-21.74c13.93-18.34,31.93-5.43,31.93-5.43,0,0-3.82,4.79-5.6,10.66-2.5,8.22,3.68,16.52,12.28,16.52h0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTide);
export default __webpack_public_path__ + "static/media/Tide.48e360e85f9fe60940cafadb5f2b7eb2.svg";
export { ForwardRef as ReactComponent };